import * as Models from '../commonModels';
import * as CarModels from '../car/car';
import * as DepositeModels from '../deposite/deposite';
import * as GarageModels from '../garage/garage';
import * as TyreOrderModels from '../tyre-order/tyre-order';

export class GarageVisitsPlaceListModel extends Models.ListBaseModel {
  Items: GarageVisitsPlaceModel[];
}

export class GarageVisitsPlaceModel {
  public GaragePlaceId: number;
  public GarageId: number;
  public Name: string;
  public IsEnableOnline: boolean;
  public CasualDayOpenHour: number;
  public CasualDayCloseHour: number;
  public SaturdayOpenHour: number;
  public SaturdayCloseHour: number;
  public SundayOpenHour: number;
  public SundayCloseHour: number;
  public AddDate: Date;
  public IsActive: boolean;
  public IsEnableCar: boolean;
  public IsEnableTruck: boolean;

  public PlaceTimeSlot: GarageVisitsPlaceTimeSlotModel[];
}

export class GarageVisitsPlaceSearch extends Models.SearchBaseModel {
  public GarageId: number;
  public Date: Date;
  public IsActive: boolean;
  public DateId: number;
}


export class GarageBlockedListModel extends Models.ListBaseModel {
  Items: GarageBlockedModel[];
}

export class GarageBlockedHourSearch extends Models.SearchBaseModel {
  public GarageId: number;
  public Date: Date;
}

export class GarageBlockedModel {
  public VisitBlockedHoursId: number;
  public GarageId: number;
  public Time: Date;
  public Date: Date;
  public Day: any;
  public Month: any;
  public Year: any;
  public Hour: any;
  public Minutes: any;
  public DateId: number;
}

export class GarageVisitsModelResponse extends Models.ListBaseModel {
  Items: GarageVisitsPlaceModel[];

  public TimeSlots: GarageVisitsTimeSlotModel[];
}

export class GarageVisitsTimeSlotModel {
  public Id: number;
  public Label: string;
  public IsBlocked: boolean;
  public Hour: number;
  public Minutes: number;
}

export class GarageVisitsPlaceTimeSlotModel {
  public Visit: GarageVisitModel;
  public TimeSlot: GarageVisitsTimeSlotModel;
}


export class GarageVisitModel {
  public GarageVisitId: number;
  public BaseGarageVisitId: number;
  public GarageId: number;
  public GaragePlaceId: number;
  public CarId: number;
  public CarTypeId: number;
  public GarageVisitsCarTypeId: number;
  public RegistrationNumber: string;
  public Date: Date;
  public VisitDate: string;
  public FirstName: string;
  public LastName: string;
  public Telephone: string;
  public Mail: string;
  public CustomerId: number;
  public CompanyName: string;
  public VisitTyreSourceId: number;
  public TyreId: number;
  public TyreName: string;
  public Note: string;
  public SentSmsDate: Date;
  public SentEmailDate: Date;
  public MeterReading: number;
  public AddedByUserId: number;
  public AddDate: Date;
  public IsActive: boolean;
  public TyreFromDepositeId: number;
  public TyreFromOrderId: number;
  public CarWmakesName: string;
  public CarWmodelName: string;
  public TyresWithRims: boolean;

  public TimeSlotId: number;
  public TimeSlotLabel: string;
  public DateId: number;
  public GaragePlaceName: string;
  public GaragePlaceIsEnableCar: boolean;
  public GaragePlaceIsEnableTruck: boolean;
  public GarageName: string;
  public TyreDiameter: number;

  public Deposites: DepositeModels.DepositePreviewModel[];

  public TyreOrders: TyreOrderModels.TyreOrderModel[];

  public IsDeleteDone: boolean;

  public IsTruck: boolean;

  public VisitTyreSource: string;

  public AddedByUser: string;

  public CustomerFullName: string;

  public UserTypeId: number;

  public IsNewVisitEmailConfirmation: boolean;

  public IsNewVisitSMSConfirmation: boolean;

  public Garage: GarageModels.GaragePreviewModel;

  public IsAldConsentToAdvertising: boolean;

  public ServiceTyreName: string;

  public IsAldConsent: boolean;
}

export class GarageVisitsSearchModel extends Models.SearchBaseModel{
  public GarageId: number;
  public CarId: number;
  public CarTypeId: number;
  public CustomerId: number;
  public Garage: string;
  public Customer: string;
  public RegistrationNumber: string;
  public DateFrom: Date;
  public DateTo: Date;
  public DataRange: DataRangeType;
  public PeriodDateRange: Models.DateRange;
  public Telephone: string;
  public Mail: string;
  public FirstName: string;
  public LastName: string;
  public GaragePlaceId: number;
  public IsOnlyMainVisits: boolean;

  constructor() {
    super();
    this.PeriodDateRange = new Models.DateRange();
  }
}

export enum DataRangeType {
  None = 0,
  Day = 1,
  Week = 2,
  Month = 3
}

export enum VisitTyreSourceType {
  Own = 1,
  Deposite = 2,
  TyreOrder = 3
}


export class GarageVisitRequestModel {
  public GarageVisitRequestId: number;
  public GarageId: number;
  public CarId: number;
  public Date: Date;
  public CustomerId: number;
  public CompanyName: string;
  public Note: string;
  public AddedByUserId: number;
  public AddDate: Date;
  public IsActive: boolean;
  public TyreFromDepositeId: number;
  public TyreFromOrderId: number;

  public Deposite: DepositeModels.DepositePreviewModel;

  public TyreOrder: TyreOrderModels.TyreOrderModel;

  public AddedByUser: string;

  public Garage: GarageModels.GaragePreviewModel;
}

export class VisitTyreSourceModel {
  public VisitTyreSourceId: number;
  public Name: string;
}

export class CarCheckModel {
  public IsCustomerCar: boolean;
  public GaragesWithDeposites: GarageModels.GaragePreviewModel[];
}

export class GarageVisitsCarTypeModel  {
  GarageVisitsCarTypeId: number;
  Name: string;
  CarTypeId: number;
  GarageVisitTimeSlots: number;
}
